export default class GenCli {
    constructor(resource) {
        this._resource = resource('gencli_supo');
    }

    get() {
        return this._resource
            .get()
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    getStatus(cnpj) {
        return this._resource
            .get({ cnpj: cnpj })
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    update(rdata) {
        return this._resource
            .update({}, rdata)
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }
}